<div class="mt-modal widget-configuration-modal">

    <div class="close-modal" (click)="closeModal()">
        <img appImageSelector alt="mt-image" imageType="icon" [imageKey]="'close-gray'">
    </div>

    <div class="header">
        <div class="title">Configurar Widget {{widget.visibleName | lang | titlecase}}</div>
    </div>
    
    <form [formGroup]="widgetForm">
        <div class="content flex-row">
            <div class="form-group">
                <app-input
                    [theme]="'light'"
                    [size]="'large'"
                    [clearable]="true"
                    [label]="'widget-title' | lang"
                    [requiredField]="true"
                    [tooltipDescription]="'widget-config-hint-1' | lang"
                    formControlName="visibleName">
                </app-input>
            </div>

            <div class="form-group">
                <app-input
                    [theme]="'light'"
                    [size]="'large'"
                    [clearable]="true"
                    [label]="'widget-description' | lang"
                    [requiredField]="true"
                    [tooltipDescription]="'widget-config-hint-2' | lang"
                    formControlName="description">
                </app-input>
            </div>

            <div class="form-group">
                <app-input
                    [theme]="'light'"
                    [size]="'large'"
                    [clearable]="true"
                    label="{{'widget-timeout' | lang}} ({{'milliseconds' | lang | lowercase}})"
                    [requiredField]="true"
                    [tooltipDescription]="'widget-config-hint-3' | lang"
                    formControlName="timeout">
                </app-input>
            </div>

            <div class="form-group">
                <app-input
                    [theme]="'light'"
                    [size]="'large'"
                    [clearable]="true"
                    label="{{'widget-delay' | lang}} ({{'milliseconds' | lang | lowercase}})"
                    [requiredField]="true"
                    [tooltipDescription]="'widget-config-hint-4' | lang"
                    formControlName="delay">
                </app-input>
            </div>

            <div class="form-group">
                <app-dropdown-selector
                    [items]="numberArray"
                    [label]="'widget-order-element' | lang"
                    bindLabel="name"
                    bindValue="value"
                    [requiredField]="true"
                    placeholder="-- {{'select' | lang}} --"
                    [tooltipDescription]="'widget-config-hint-5' | lang"
                    formControlName="orderElement">
                </app-dropdown-selector>
            </div>

            <div class="form-group">
                <app-dropdown-selector
                    [items]="isEnabledOptions"
                    [label]="'widget-enabled' | lang"
                    bindLabel="name"
                    bindValue="value"
                    placeholder="-- {{'select' | lang}} --"
                    [requiredField]="true"
                    [tooltipDescription]="'widget-config-hint-6' | lang"
                    formControlName="isEnabled">
                </app-dropdown-selector>
            </div>

            <div class="form-group">
                <app-dropdown-selector
                    [items]="classNumbers"
                    [label]="'widget-class' | lang"
                    bindLabel="name"
                    bindValue="value"
                    placeholder="-- {{'select' | lang}} --"
                    [requiredField]="true"
                    [tooltipDescription]="'widget-config-hint-7' | lang"
                    formControlName="class">
                </app-dropdown-selector>
            </div>
        </div>
    </form>

    <div class="footer flex-row">
        <div class="mandatory">
            <span class="orange">*</span> {{ 'mandatory fields' | lang }}
        </div>

        <div class="buttons">
            <button class="btn btn-gray" (click)="closeModal()" [disabled]="isLoading">{{ 'cancel' | lang }}</button>
            <button class="btn btn-orange" 
                (click)="changeConfiguration()"
                [disabled]="hasError || isLoading"
                >
                {{ 'change condition' | lang }}
            </button>
        </div>

        <div class="status-message" [style.height]="changeStatus === 'success' ? '20px' : '0'">
            <img appImageSelector alt="mt-image" imageKey="check-green" imageType="icon">
            {{ 'change done successfully' | lang }}
        </div>

        <div class="status-message" [style.height]="changeStatus === 'error' ? '20px' : '0'">
            <img appImageSelector alt="mt-image" imageKey="error-red" imageType="icon">
            {{ 'it could not make the change' | lang }}
        </div>
    </div>
</div>